import { useMemo } from 'react';
import { useGetCatalogQuery, useWorkspaceRecordsQuery } from '@platform/state/api';
import type { ITreeNode } from '@platform/core/types';
import { mainRecordTypes } from '../../shell/mainRecordTypes';
import { subtreeCounts } from './pathRows';

/**
 * Кількість записів у кожному вузлі шляхів (з нащадками) за записами головних таблиць простору (той самий запит, що й бізнес-аналітика):
 * поле `area` або `iteration` запису — ідентифікатор вузла. undefined — ще вантажиться.
 */
export function usePathCounts(ws: string, field: 'area' | 'iteration', nodes: readonly ITreeNode[] | undefined): Map<string, number> | undefined {
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws }, { skip: !ws });
  const { data } = useWorkspaceRecordsQuery({ ws, types: mainRecordTypes(catalog) }, { skip: !catalog });
  return useMemo(() => {
    if (!data || !nodes) return undefined;
    const direct = new Map<string, number>();
    for (const r of data.items) {
      const id = r.values[field];
      if (typeof id === 'string') direct.set(id, (direct.get(id) ?? 0) + 1);
    }
    return subtreeCounts(nodes, direct);
  }, [data, nodes, field]);
}
